export enum EmailClient {
  Sendgrid = 'sendgrid',
  Outlook = 'outlook',
}
